import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-43e9e25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-layout" }
const _hoisted_2 = { class: "profile-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-header-bg" }, null, -1))
const _hoisted_4 = { class: "profile-header-info" }
const _hoisted_5 = { class: "avatar-box" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "email" }
const _hoisted_10 = { class: "profile-content" }
const _hoisted_11 = { class: "profile-aside" }
const _hoisted_12 = { class: "menu" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-link-icon tabler-icon-logout" }, null, -1))
const _hoisted_14 = { class: "profile-content-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["AppHeader"]),
    _createElementVNode("main", null, [
      _createElementVNode("header", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            ($setup.userStore.userData?.avatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "avatar-img",
                  src: $setup.userStore.userData?.avatar?.url,
                  alt: "User's avatar"
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("abbr", {
                  key: 1,
                  class: "avatar-abbr",
                  title: $setup.userStore.userData?.first_name + ' ' + $setup.userStore.userData?.last_name
                }, _toDisplayString($setup.userStore.userData?.first_name[0]) + _toDisplayString($setup.userStore.userData?.last_name[0]), 9, _hoisted_7))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h5", _hoisted_8, _toDisplayString($setup.userStore.userData?.first_name + " " + $setup.userStore.userData?.last_name), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString($setup.userStore.userData?.email), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("aside", _hoisted_11, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.menuOptions, (item, idx) => {
                return _createElementVNode("li", {
                  class: "menu-item",
                  key: idx
                }, [
                  (!item.action)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "nav-link",
                        to: { name: item.routeName }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["nav-link-icon", item.iconName])
                          }, null, 2)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ])
              }), 64)),
              _createElementVNode("li", { class: "menu-item" }, [
                _createElementVNode("button", {
                  class: "nav-link",
                  onClick: $setup.onLogout
                }, [
                  _createTextVNode("Logout"),
                  _hoisted_13
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}